export default __webpack_public_path__ + "static/whereisthat_logo-307aa97acf1bdff04bb037087553436c.png";